import { listStyles as styles } from "@insite/content-library/Widgets/MyLists/MyListsList";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.cardContainer = {
    ...styles.cardContainer,
    gridItem: {
        ...styles.cardContainer?.gridItem,
        css: css`
            ${styles.cardContainer?.gridItem?.css}
            border: 1px solid ${getColor(colorStrings.commonBorder)};
        `,
    },
    cardDivider: {
        ...styles.cardContainer?.cardDivider,
        css: css`
            ${styles.cardContainer?.cardDivider?.css}
            border: 0;
            margin: 0 0 -1px;
            width: 100%;
        `,
    },
};

styles.cardList = {
    ...styles.cardList,
    gridContainer: {
        ...styles.cardList?.gridContainer,
        gap: 0,
        offsetCss: css`
            ${styles.cardList?.gridContainer?.css}

            ${mediaQueriesBP.minMD} {
                margin-block-start: 40px;
            }

            /* first item should have border radius on top only */
            > *:first-child > div {
                border-top-left-radius: 4px;
                border-top-right-radius: 4px;
            }

            /* last item should have border radius on bottom only */
            > *:last-child > div {
                border-bottom-left-radius: 4px;
                border-bottom-right-radius: 4px;
            }
        `,
    },
};
